import React from "react";
import axios from "axios";
import { api } from "./api/client";
import MUIDataTable from "mui-datatables";
import {createTheme, MuiThemeProvider} from "@material-ui/core/styles";
import {utils, write} from "xlsx";
import { saveAs } from 'file-saver'
import moment from "moment";
import Dialog from '@mui/material/Dialog';
import Switch from '@mui/material/Switch';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Select from "react-select";
import {adaptV4Theme} from "@mui/material/styles";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";
const styles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'orange' : 'gray',

        lineHeight: 1
    }),
    control: () => ({
        // none of react-select's styles are passed to <Control />
        position:'relative',
        width: 200,
        lineHeight: 1
    }),

}
class ExpandableRowIsEmirleriGunler extends React.Component {
    rows;
    lokasyonlarRows;
    technologyList = [];
    customerList =  [];

    constructor(props) {
        super(props);
        this.state={childRows:[], childRowId:0,locations:[], locationChangeOpen:false,customerChangeOpen:false
            ,customerID:0,locationID:0,machineID:0, selected: null};
        this.getDatas();

    }

     changeLocationConfirm = (locationID,machineID) => {
       this.setState({locationChangeOpen:true,locationID:locationID,machineID:machineID});
    };

    changeCustomerConfirm = (customerID,machineID) => {
        this.setState({customerChangeOpen:true,customerID:customerID,machineID:machineID});
    };

    locationChangeClose = () => {
         this.setState({locationChangeOpen:false,locationID:0,machineID:0});
     };

    customerChangeClose = () => {
        this.setState({customerChangeOpen:false,customerID:0,machineID:0});
    };

    async getDatas() {

        const is_emri_no = this.props.rowData[0].props.isEmriNo;
        console.log('işemirbilileri',this.props.rowData[0].props.isEmriNo);
        const row = await api.get(`/is-emirleri/${encodeURIComponent(is_emri_no)}/gunler`);
        const gunler = Array.isArray(row.data) ? row.data : (row.data?.data || []);
        this.rows = gunler;

        const notes = this.rows.map(d => ({

            "id": d.id,
            "aciklama" :  d.aciklama,
            "tarih":d.tarih,
            "kayit_zamani":d.time_stamp ,
            "files":d.files,
            "kd":d.kd
         }))
        //console.log(products);
        this.setState({childRows: notes})


    }



    async changeLocation(locationID, machineID) {

        await api.post(`/lookups/makineler/${machineID}/lokasyon`, null, {
            params: { lokasyon_id: locationID }
        })
            .then((response) => {
                // Success 🎉
                console.log(response);
                this.getDatas();
                this.locationChangeClose();

            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });

    }


    render() {
        let datas=[];
        let data= this.state.childRows;
        const {selected} = this.state;
        const options = {
            filter: false,
            onFilterChange: (changedColumn, filterList) => {
                //console.log(changedColumn, filterList);
            },
            selectableRows: false,
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: 100,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '100%',
            print:false,
            download:true,
            draggableColumns: {
                enabled:false,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 8,
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },
            onRowSelectionChange : (curRowSelected, allRowsSelected) => {
                datas.length=0;
                console.log("---RowSelect")
                console.log("Row Selected: ", curRowSelected);
                console.log("All Selected: ", allRowsSelected);

                if(allRowsSelected) {
                    allRowsSelected.forEach((result)=>{
                        datas.push(this.state.childRows[result.dataIndex]);
                    })
                }
            },
            textLabels :{
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                //console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Makine Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },
            expandableRows: false,


        };

            const myTheme  = createTheme(adaptV4Theme({

                overrides: {
                 MUIDataTableToolbar:{
                    root:{
                        display: "none"
                    }
                },
                MUIDataTableFooter:{
                    root:{
                        display: "none"
                    }
                },
                MUIDataTableHeadCell:{
                   root: {



                    }},
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e3a165 !important",
                        fontWeight: "bold",
                        padding:1,
                        lineHeight:0.1,
                        width: '370px'
                    },

                    root: {


                    }
                },
                MUIDataTable: {

                    responsiveScroll: {
                        minHeight:'30vh',
                        width:'1200px'
                    },

                },
            },
        }));

        const columns = [

            {
                name: "tarih",
                label:"Tarih",
                options: {
                    filter:false,
                    sort:false,
                }
            },
            {
                name: "kayit_zamani",
                label: "Eklendiği Tarih",
                options: {
                    filter: false,

                },
            },
            {
                name: "aciklama",
                label: "Not",
                options: {
                    filter: false,

                },
            },
            {
                name: "files",
                label: "Dosyalar",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                        let fileList=[];
                            value.forEach(
                                function links(item , index , arr) {
                                    let link= '/dosyalar/'+arr[index];
                                    fileList.push(  <Button style={{padding:2, minWidth:30, marginRight:4}} color={'success'} variant="outlined" size={'small'} href={link} target={'_blank'} >{index}</Button> )
                                }
                            )
                            return  (
                                fileList
                            )

                        }
                    },
                }
            },
            {
                name: "kd",
                label: "Kirmizi Defter",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {

                        let checkValue=value != 0;
                            console.log('checked',checkValue)
                            return  (
                                <Switch
                                     checked={checkValue}
                                     inputProps={{ 'aria-label': 'controlled' }}
                                     color="warning"
                                />
                            )

                        }
                    },
                }
            }
        ];

        return(
            <React.Fragment>
                <Dialog
                    open={this.state.locationChangeOpen}
                    onClose={this.locationChangeClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Lokasyonu değiştirme onayı"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Bu makinenin lokasyonunu değiştirmek istediğinizden emin misiniz?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.locationChangeClose}>İptal</Button>
                        <Button onClick={()=>{this.changeLocation(this.state.locationID, this.state.machineID).then((r) => console.log(r))}}>
                            Lokasyonu Değiştir
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.customerChangeOpen}
                    onClose={this.customerChangeClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Müşteriyi değiştirme onayı"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Bu makinenin müşterisini değiştirmek istediğinizden emin misiniz?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.customerChangeClose}>İptal</Button>
                        <Button onClick={()=>{this.changeCustomer(this.state.customerID, this.state.machineID).then((r) => console.log(r))}}>
                            Müşteriyi Değiştir
                        </Button>
                    </DialogActions>
                </Dialog>


                <tr>
                <td colSpan={9}>
                    <MuiThemeProvider theme={myTheme}>
                        <MUIDataTable title={"Notlar"} data={this.state.childRows} columns={enhanceColumns(columns)} options={withTableOptions(options)} />
                    </MuiThemeProvider>
                </td>
            </tr>

        </React.Fragment> )

    };

};

export default ExpandableRowIsEmirleriGunler;
